/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Vault Radar
 * API for managing Vault Radar.
 *
 * The version of the OpenAPI document: 2023-05-01
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FilterFilterOperation;
(function (FilterFilterOperation) {
    FilterFilterOperation["UNKNOWN"] = "UNKNOWN";
    FilterFilterOperation["EQ"] = "EQ";
    FilterFilterOperation["GT"] = "GT";
    FilterFilterOperation["GE"] = "GE";
    FilterFilterOperation["LT"] = "LT";
    FilterFilterOperation["LE"] = "LE";
    FilterFilterOperation["NEQ"] = "NEQ";
    FilterFilterOperation["NEQNULLAWARE"] = "NEQ_NULL_AWARE";
    FilterFilterOperation["LIKE"] = "LIKE";
    FilterFilterOperation["ILIKE"] = "ILIKE";
})(FilterFilterOperation || (FilterFilterOperation = {}));
export function FilterFilterOperationFromJSON(json) {
    return FilterFilterOperationFromJSONTyped(json, false);
}
export function FilterFilterOperationFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FilterFilterOperationToJSON(value) {
    return value;
}
